import { Status } from "entities/users/types";
import { COLOR_BLUE, COLOR_GREEN, COLOR_YELLOW } from "shared/theme/colors";

export const getChipColor = (status: Status) => {
  if (status === Status.REGISTERED) {
    return COLOR_GREEN;
  }

  if (status === Status.BOT_INTERACTION_ONLY) {
    return COLOR_YELLOW;
  }

  return COLOR_BLUE;
};
